<div class="d-flex flex-row justify-content-between blockTitle" tooltipTruncate [matTooltip]="block.title!">
  <span #blockTitle class="slideTitle">{{ block.title }}</span>
  <mat-icon *ngIf="!isSummary && !isEmbed" class="block-title-help pr" matTooltip="{{'Help' | translate}}" (click)="onOpenHelpDialog()">help</mat-icon>
</div>
<div class="slideContent" #slideContent (scroll)="onScroll()">
  <div *ngFor="let componentsGroup of block.componentGroups;">
    <app-group-form autocomplete="off"
      [componentsGroup]="componentsGroup"
      [customerPage]="customerPage"
      [userRole]="userRole"
      [block]="block"
      [customer]="customer"
      [customersData]="customersData"
      [offerStatus]="offerStatus"
      [refBusinessLists]="refBusinessLists"
      [fullConnectionsDefinitions]="fullConnectionsDefinitions"
      [isCurrentBlock]="isCurrentBlock"
      (customersDataChange)="handleCustomerPageDatasChange($event)"
      (scrollToSchedule2)="scrollToSchedule($event)"
      (fieldContainerClick)="onGroupFormClick($event)"
      (tooltipPositions)="onTooltipPositionChanged($event)"
      (recalculateTooltipsPosition)="updateTooltipsPosition()"
      (closeAllTooltipsExceptCurrent)="closeAllTooltipErrorsOnCurrentBlock($event)"
      [isSummary]="isSummary">
    </app-group-form>
  </div>
</div>
